import React, { useEffect, useState } from 'react';
import { 
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
  PieChart, Pie, Cell
} from 'recharts';
import { analyticsService } from '../../services/analytics';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const AnalyticsDashboard = () => {
  const [report, setReport] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReport = async () => {
      setLoading(true);
      const data = await analyticsService.generateStoryReport();
      setReport(data);
      setLoading(false);
    };

    fetchReport();
  }, []);

  if (loading) {
    return <div className="loading">Loading analytics...</div>;
  }

  if (!report) {
    return <div className="error">Failed to load analytics data.</div>;
  }

  // Prepare data for charts
  const storyStatusData = [
    { name: 'Approved', value: report.approvedStories },
    { name: 'Pending', value: report.pendingStories },
  ];

  const xLinkData = [
    { name: 'With X Link', value: report.storiesWithXLinks },
    { name: 'Without X Link', value: report.totalStories - report.storiesWithXLinks },
  ];

  return (
    <div className="analytics-dashboard">
      <h2>Story Metrics Dashboard</h2>
      
      <div className="metrics-summary">
        <div className="metric-card">
          <h3>Total Stories</h3>
          <p className="metric-value">{report.totalStories}</p>
        </div>
        <div className="metric-card">
          <h3>Approval Rate</h3>
          <p className="metric-value">{report.approvalRate.toFixed(1)}%</p>
        </div>
        <div className="metric-card">
          <h3>Stories Last 7 Days</h3>
          <p className="metric-value">{report.recentStoriesCount}</p>
        </div>
      </div>
      
      <div className="charts-container">
        <div className="chart-wrapper">
          <h3>Story Status</h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={storyStatusData}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, value }) => `${name}: ${value}`}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
              >
                {storyStatusData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
        
        <div className="chart-wrapper">
          <h3>X Link Integration</h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={xLinkData}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, value }) => `${name}: ${value}`}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
              >
                {xLinkData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index + 2 % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsDashboard;